import React, { useEffect, useRef, useState } from 'react';
import CusAutocomplete from './CusAutocomplete';
import { API_GROUP } from '../../api/user';

export default function SelectGame({
  label = 'Link to the game',
  placeholder,
  groupId,
  value,
  onChange
}) {
  const searchTmRef = useRef(null);
  const [gamesOptions, setGamesOptions] = useState([]);

  const searchGame = (value) => {
    if (value.length < 3) return;

    API_GROUP.gameSearch({ groupId, sample: value })
      .then((e) => {
        const list = e.data.list;
        const gameOptions = list.map((el) => ({
          label: `${el.name} (${el.providerName}, id:${el.gameId})`,
          value: el.gameId
        }));
        setGamesOptions(gameOptions);
      })
      .catch(console.error);
  };

  const onChangeAutoCompile = (e) => {
    const value = e.target.value;

    if (!value) setGamesOptions([]);

    clearTimeout(searchTmRef.current);
    searchTmRef.current = setTimeout(() => {
      const value = e.target.value;
      searchGame(value);
    }, 300);
  };

  return (
    <CusAutocomplete
      freeSolo
      label={label}
      placeholder={placeholder}
      isAlwaysOptions
      options={gamesOptions}
      value={value}
      onChange={onChange}
      textFieldProps={{ onChange: onChangeAutoCompile }}
    />
  );
}
